import "intl-tel-input/build/css/intlTelInput.css";
import "intl-tel-input/build/js/utils.js";
import intlTelInput from "intl-tel-input";

const input = document.querySelector("#phone");

// Function to convert Arabic numerals to Western numerals
function convertArabicToWesternNumerals(text) {
  const arabicNumerals = ["٠", "١", "٢", "٣", "٤", "٥", "٦", "٧", "٨", "٩"];
  return text.replace(/[٠-٩]/g, match => arabicNumerals.indexOf(match).toString());
}

const iti = intlTelInput(input, {
  autoPlaceholder: "polite",
  autoInsertDialCode: true,
  separateDialCode: true,
  initialCountry: "ae",
  preferredCountries: ["ae", "sa"],
  formatOnDisplay: true,
  customPlaceholder: function(selectedCountryPlaceholder, selectedCountryData) {
    if(selectedCountryData.iso2 === 'ae'){
      input.setAttribute('maxlength','9');
      input.setAttribute('minlength','9');
      return "55 123 4567";
    }
    else{
      return "e.g. " + selectedCountryPlaceholder;
    }
  },
});

input.addEventListener("countrychange", function () {
  let valid = iti.isValidNumber();
  let validFormat = intlTelInputUtils
    .getExampleNumber(iti.getSelectedCountryData().iso2, true, 1)
    .replace(/[^0-9]/g, "");
  input.setAttribute("data-max", validFormat.length);
  valid
    ? this.closest("fieldset").classList.remove("error")
    : this.closest("fieldset").classList.add("error");

  let phoneCountryCodeInput = document.getElementById('phone_country_code');
  if(phoneCountryCodeInput != null){
    phoneCountryCodeInput.value = "+"+iti.getSelectedCountryData().dialCode;
  }
});

input.addEventListener("input", function () {
  // Convert Arabic numerals to Western numerals
  const convertedValue = convertArabicToWesternNumerals(input.value);
  // console.log("Original Value: " + input.value);
  // Update the input field with the converted value
  input.value = convertedValue;

  let value = input.value.replace(/[^0-9]/g, "");
  input.value =
    value.length > Number(input.dataset.max)
      ? value.substring(0, Number(input.dataset.max))
      : value;
  let valid = iti.isValidNumber();
  valid
    ? this.setAttribute("data-valid", true)
    : this.setAttribute("data-valid", false);
  valid
    ? this.closest("fieldset").classList.remove("error")
    : this.closest("fieldset").classList.add("error");
});